<template>
    <div class="w-full h-auto relative">
        <img src="../../assets/img/Mobile/Frame 113.webp" alt="" class="w-full">
        <div class="w-full h-[20vw] bg-gradient-to-t from-[#171717] to-transparent absolute bottom-0"></div>
        <img src="../../assets/img/Mobile/topInner.webp" alt="" class="absolute top-0 left-0 w-full">
        <div class="absolute top-0 left-0 w-full flex flex-col justify-center mt-[4vw]">
            <p class="font-emeritus text-white text-center text-[8vw]">CONQUER</p>
            <p class="font-emeritus text-white text-center leading-[5vw] text-[6.3vw]">THE VAST WORLD</p>
        </div>

        <img src="../../assets/img/Mobile/inner.webp" alt="" class="absolute top-[38vw] w-[95vw] left-[2.5vw]">
        <img src="../../assets/img/Mobile/innerBossFight.webp" alt="" class="absolute top-[80vw] w-[95vw] left-[2.5vw]">

        <div class="absolute w-[95vw] left-[2.5vw] top-[120vw] flex flex-row justify-between">
            <img src="../../assets/img/Mobile/innerPvP.webp" alt="" class="w-[45vw]">
            <img src="../../assets/img/Mobile/innerBossFightVertical.webp" alt="" class="w-[45vw]">
        </div>
        <img src="../../assets/img/Desktop/ConquerTheVastWorld/frame7.webp" alt="" class="absolute left-[2.5vw] top-[51.67vw] w-[51.16vw]">
    </div>
</template>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}
</style>